import { Component } from '@angular/core';

@Component({
    selector: 'app-receipt-layout',
    templateUrl: './receipt-layout.component.html',
    styleUrl: './receipt-layout.component.scss',
})
export class ReceiptLayoutComponent {}
